// extracted by mini-css-extract-plugin
export default {"white":"Transition_white__zWyWJ","blue":"Transition_blue__eGqRn","overlay":"Transition_overlay__bhCTY","loading-text":"Transition_loading-text__-hahX"};